import permisosPersona, { RESOURCE_PERSONA } from '@/auth/permissions/modules/personaPg'
import { defineMenu } from '@/utils/menu'
import * as names from '@routes/persona-pg/nombres/mantenimiento'

const { mantenimiento } = permisosPersona
export default defineMenu([
    {
        title: 'persona.subopciones.entidades',
        route: names.ROUTE_ENTIDADES,
        resource: RESOURCE_PERSONA,
        action: mantenimiento.entidades,
    },
    {
        title: 'persona.subopciones.proveedor',
        route: names.ROUTE_PROVEEDOR,
        resource: RESOURCE_PERSONA,
        action: mantenimiento.proveedor,
    },
])
